import React from "react";
import { Link } from "gatsby";
import { Reveal } from "./Reveal";
import Wordmark from "./Wordmark";
import OpenNow from "./OpenNow";

export default function Footer() {
  return (
    <footer className="ft">
      <div className="container">
        <div className="ft-cta">
          <Reveal>
            <p className="eyebrow">Walk in <span className="jp">来店</span></p>
            <h2 className="h1" style={{ marginTop: 24 }}>No reservations.<br /><span className="shu">Just come.</span></h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="body-lg" style={{ maxWidth: 440 }}>Tuesday to Sunday, 11 am to 7 pm. The line moves. After 2 for a late lunch or before 5 for an early dinner, you will usually be seated straight away.</p>
            <div style={{ marginTop: 28 }}><OpenNow /></div>
          </Reveal>
        </div>
        <hr className="rule" />
        <div className="ft-grid">
          <div className="ft-col">
            <p className="eyebrow no-rule">Find us</p>
            <p>1365 Osage Street<br />Denver, Colorado 80204<br /><span className="ash">Next to Nippon Kan, one block west of Santa Fe</span></p>
            <p style={{ marginTop: 16 }}><a href="https://maps.google.com/?q=DOMO+Japanese+Country+Foods+1365+Osage+St+Denver+CO+80204" target="_blank" rel="noreferrer" className="link-line">Directions</a></p>
          </div>
          <div className="ft-col">
            <p className="eyebrow no-rule">Hours</p>
            <p>Tuesday to Sunday<br /><span className="ash">11 am to 7 pm</span></p>
            <p style={{ marginTop: 10 }}>Monday<br /><span className="ash">Closed</span></p>
          </div>
          <div className="ft-col">
            <p className="eyebrow no-rule">Explore</p>
            <ul className="ft-list">
              <li><Link to="/menu/">Menu</Link></li>
              <li><Link to="/garden/">Garden &amp; museum</Link></li>
              <li><Link to="/story/">Our story</Link></li>
              <li><Link to="/visit/">Visit</Link></li>
              <li><a href="https://www.nipponkan.org" target="_blank" rel="noreferrer">Nippon Kan aikido</a></li>
            </ul>
          </div>
          <div className="ft-col">
            <p className="eyebrow no-rule">Talk to us</p>
            <ul className="ft-list">
              <li><a href="tel:+13035953666">303 595 3666</a></li>
              <li><a href="mailto:domo.japaneserestaurant@gmail.com">domo.japaneserestaurant@gmail.com</a></li>
              <li><a href="https://www.facebook.com/domorestaurantdenver/" target="_blank" rel="noreferrer">Facebook</a></li>
            </ul>
          </div>
        </div>
        <div className="ft-mark" aria-hidden="true"><Wordmark size={6} sub={false} /></div>
        <div className="ft-bottom">
          <span>© {new Date().getFullYear()} DOMO Japanese Country Foods Restaurant. Denver, since 1996.</span>
          <span className="ash">大衆食堂 どうも</span>
        </div>
      </div>
      <style dangerouslySetInnerHTML={{ __html: `
        .ft { position: relative; padding-top: clamp(96px, 12vw, 180px); background: var(--sumi); overflow: hidden; }
        .ft::before { content: ""; position: absolute; inset: 0; background: radial-gradient(50% 40% at 50% 100%, rgba(184,58,43,.14), transparent 70%); pointer-events: none; }
        .ft-cta { display: grid; grid-template-columns: 1.3fr 1fr; align-items: end; gap: 40px; padding-bottom: clamp(64px, 8vw, 120px); }
        .ft-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 40px; padding: clamp(48px, 6vw, 96px) 0; font-size: .95rem; line-height: 1.7; color: var(--washi-2); }
        .ft-col .eyebrow { margin-bottom: 18px; }
        .ft-list { list-style: none; margin: 0; padding: 0; display: grid; gap: 6px; }
        .ft-list a { transition: color .3s; } .ft-list a:hover { color: var(--shu-2); }
        .ft-mark { opacity: .06; text-align: center; pointer-events: none; margin-bottom: -2%; }
        .ft-mark .wm-en { font-size: clamp(5rem, 22vw, 24rem); }
        .ft-bottom { display: flex; justify-content: space-between; gap: 20px; flex-wrap: wrap; padding: 28px 0 36px; font-size: .72rem; letter-spacing: .12em; text-transform: uppercase; border-top: 1px solid rgba(243,236,221,.08); position: relative; }
        @media (max-width: 900px) { .ft-cta { grid-template-columns: 1fr; } .ft-grid { grid-template-columns: 1fr 1fr; } }
      ` }} />
    </footer>
  );
}
